import React from 'react'
import Intro from './Intro'
import Faq from '../global/Faq'
import Vision from './Vision'

const AboutMe = () => {
    const aboutMeFaqs = [
        {
            id: 1,
            question: "Do you have formal education in your field?",
            answer: "I am currently pursuing a major in Software Engineering at ARID University, where I consistently excel academically while actively honing my skills as an industry-experienced web developer.",
        },
        {
            id: 2,
            question: "Do you have any industry experience?",
            answer: "Yes, I have been working in the tech industry for 2 years. I began as a Frontend React intern, where I focused on handling the frontend of websites, including UI design and managing dynamic data from the backend like Integration. Currently, I'm freelancing, leveraging my experience to deliver high-quality web solutions to clients.",
        },
        {
            id: 3,
            question: "What services do you offer as a web developer?",
            answer: "As a web developer, I offer a variety of services including custom-made Figma designs, personal portfolio websites, full-stack e-commerce websites, personal branding sites, dynamic-dashboards, and web applications. Whether you need a sleek and professional portfolio to showcase your work or a fully functional e-commerce platform, I can provide tailored solutions to meet your needs.",
        },
        {
            id: 4,
            question: "What programming languages and technologies are you most proficient in?",
            answer: `For frontend, I am proficient in HTML, CSS (including Tailwind CSS, SASS and Bootstrap), JavaScript, TypeScript, React.js, and Next.js. For backend development, I specialize in NodeJs, RestAPI, MongoDB, SupaBase and MySQL.`,
        },
        {
            id: 5,
            question: "Can you share some of the projects you've worked on in the tech industry?",
            answer: "Visit My Projects page, where you can explore the various projects I have worked on and get to know my skills.",
        },
        {
            id: 6,
            question: "How did you gain your expertise in solving programming problems and debugging?",
            answer: "Whenever someone asks me how to become an expert in programming, my answer is always practice. Practice is the key to becoming a very good programmer. I have been programming for 3 years, and I practice daily, working on new projects regularly. This consistent effort has allowed me to gain expertise in solving programming problems and debugging.",
        },
        {
            id: 7,
            question: "What types of freelance projects have you worked on before?",
            answer: "I have worked on numerous freelance projects, including personal branding websites, e-commerce (estore) websites, admin dashboards, portfolio websites, content management systems (CMS), and custom web applications tailored to meet specific client needs. For more examples, please visit my projects page.",
        },
        {
            id: 8,
            question: "What is your approach to handling multiple freelance projects simultaneously?",
            answer: "As I mentioned earlier, I have a team of skilled developers. When I have a heavy workload, I rely on their help to meet deadlines and maintain the quality of the product.",
        },

    ];
    return (
        <>
            {/* <Hero/> */}
            <Vision />
            <Intro />
            <Faq faqsData={aboutMeFaqs} />
        </>
    )
}

export default AboutMe